import { render, staticRenderFns } from "./EditRegion.vue?vue&type=template&id=c7f75452"
import script from "./EditRegion.vue?vue&type=script&lang=js"
export * from "./EditRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports